/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ConfirmChangeEmailPresenter from './ConfirmChangeEmail.presenter';

import userActions from 'redux/actions/user';
import navigationActions from 'redux/actions/navigation';
import sessionActions from 'redux/actions/session';

import api from 'api';
import routeNames from 'lib/routeNames';


function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    goHome: () => {
      dispatch(navigationActions.goTo(routeNames.home()));
    },

    requestUser: (userId) => {
      return dispatch(userActions.request(userId));
    },

    logout: () => {
      dispatch(sessionActions.logout());
    },
  }
}

class ConfirmChangeEmail extends React.Component {

  constructor(props) {
    super(props);

    this.confirmEmailChange = this.confirmEmailChange.bind(this);
    this.confirmEmailChangeMfa = this.confirmEmailChangeMfa.bind(this);

    this.state = {
      password: '',
      passwordSubmitted: false,
      confirmationSuccess: false,
    };
  }

  confirmEmailChangeMfa(userId, token, password, mfaCode) {
    return api.sessionApi.mfaChangeEmail(token, password, mfaCode, 'short')
    .then(() => this.props.requestUser(userId))
    .then(() => this.props.goHome());
  }

  confirmEmailChange(userId, token, password) {
    return api.sessionApi.changeEmail(token, password, 'short')
    .then(() => this.props.requestUser(userId))
    .then(() => this.props.goHome());
  }

  render() {
    return (
      <ConfirmChangeEmailPresenter
        confirmEmailChangeMfa={this.confirmEmailChangeMfa}
        confirmEmailChange={this.confirmEmailChange}
        logout={this.props.logout}
        token={this.props.token}
      />
    );
  }
}
ConfirmChangeEmail.propTypes = {
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmChangeEmail);
